import Button from 'components/forms/Button'
import { FC } from 'react'
import { businessBankingStrings } from 'common/strings/business-banking-strings'

type Props = {}

const FreeBusinessBanking: FC<Props> = () => {
  return (
    <div className={'d-flex flex-column text-center px-lg-21'}>
      <h2 className='fs-fluid-36-80 fw-semibold mb-6 mb-lg-9 lh-105 whitespace-nowrap'>
        <span> Free business banking and </span>{' '}
        <br className='d-none d-lg-block' />{' '}
        <span> more — only with the Hoxton Mix.</span>
      </h2>
      <div className='d-flex flex-column gap-6 fs-fluid-24-32 fw-semibold lh-119'>
        <span>
          {businessBankingStrings.tideCashBackAmount} cashback with Tide — your
          business banking sorted.
        </span>
        <span>
          Xero online accounting software — 90% off for 6 months. Accounts,
          done.
        </span>
        <span>
          Slack — 25% off for the first year. Communication made easy.
        </span>

        <span>
          Capital on Tap business credit card —{' '}
          {businessBankingStrings.tideCashBackAmount} cashback. Expenses
          covered.
        </span>
      </div>
      <p className='fs-fluid-18-20 fw-semibold color-grey5 lh-119 lh-lg-114 pt-6 pt-lg-9 px-lg-14'>
        Our aim has always been to support business growth. Working with our
        partners, we've negotiated exclusive deals and offers for our members.
        We also use many of our partners' services and products ourselves — we
        only promote those we genuinely believe are worth using. Whether you
        need a business bank account, a credit card, accounting software, or
        tools to connect your team — we've got a deal for you. We regularly
        update our offers, so be sure to sign up and save even more.
      </p>
      <div className='d-flex justify-content-center'>
        <img
          src='/images/new/tide/account-switch-guarantee.svg'
          alt='Account switch guarantee'
          width={200}
          className='img-fluid mt-2'
        />
      </div>
      <a
        target='_blank'
        href='https://www.tide.co/partners/hoxton-mix/?utm_source=webpage&utm_medium=webpage'
        rel='noreferrer'
      >
        <Button className='w-100 w-lg-auto mx-auto mt-8 mt-lg-9'>
          Open an account
        </Button>
      </a>
    </div>
  )
}

export default FreeBusinessBanking
